import {
  HttpInterceptorFn,
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const HttpErrorInterceptorFn: ()=>HttpInterceptorFn = (): HttpInterceptorFn => {
  return (req, next) => next(req).pipe(
    catchError((error, caught) => {
      (error as any).request = req;
      return throwError(()=>error);
    }),
  );
}

